import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { apiFetch } from '@shared/api/http'
import { ProductSchema, ProductsSchema } from './product.contract'
import type { Product } from './product.contract'

export const productKeys = {
  all: ['products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  detail: (productId: string) => [...productKeys.all, 'detail', productId] as const,
}

export const CheckoutExperienceModeSchema = z.enum(['FORCE_NEW', 'FORCE_LEGACY', 'RANDOM'])
export type CheckoutExperienceMode = z.infer<typeof CheckoutExperienceModeSchema>

const CatalogRuntimeCapabilitiesSchema = z.object({
  minuteBillingEnabled: z.boolean(),
  checkoutExperienceMode: CheckoutExperienceModeSchema.catch('FORCE_NEW'),
})

export function catalogRuntimeCapabilitiesQuery() {
  return queryOptions({
    queryKey: [...productKeys.all, 'runtime-capabilities'] as const,
    queryFn: async () => {
      const data = await apiFetch<unknown>('/catalog/runtime-capabilities')
      return CatalogRuntimeCapabilitiesSchema.parse(data)
    },
  })
}

export function productsQuery() {
  return queryOptions({
    queryKey: productKeys.lists(),
    queryFn: async (): Promise<Product[]> => {
      const data = await apiFetch<unknown>('/catalog/products')
      return ProductsSchema.parse(data)
    },
  })
}

export function productQuery(productId: string) {
  return queryOptions({
    queryKey: productKeys.detail(productId),
    queryFn: async (): Promise<Product> => {
      const data = await apiFetch<unknown>(`/catalog/products/${productId}`)
      return ProductSchema.parse(data)
    },
    enabled: Boolean(productId),
  })
}
